export default __webpack_public_path__ + "static/media/AIRES DE COVOITURAGE.83d7ca1c.svg";